import Banner1 from "../components/landing/Banner1";
import Banner2 from "../components/landing/Banner2";
import style from "../pages/landing.module.css";
import Banner3 from "../components/landing/Banner3";
import { useState } from "react";
import HeadingAnimation from "../components/animations/heading";
import SubHeadingAnimation from "../components/animations/subHeading";
import { Helmet } from "react-helmet";

const LandingPage = () => {
  const heading =
    "Payments for the digital age to connect, and transact with fewer fees";
  const sub =
    "nuBlock portal enables seamless crypto payments, real-time stablecoin swaps, and wallet-free onboarding for your users or customers without complexity.";

  const [headingCompleted, setHeadingCompleted] = useState(false);

  return (
    <>
      <Helmet>
        <title>nuBlock</title>
        <meta
          name="description"
          content="The payments network for a borderless world."
        />
        <meta
          name="keywords"
          content="social, directo, directoapp, payments, crypto, nu, nublock, nuconsortium"
        />
        <meta name="author" content="directoapp" />
        <meta property="og:title" content="nuBlock" />
        <meta
          property="og:description"
          content="The payments network for a borderless world."
        />
        <meta property="og:url" content="https://nublock.xyz/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={"%PUBLIC_URL%/logo.png"} />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:height" content="200" />
        <meta property="og:image:width" content="200" />
        <meta name="twitter:title" content="nuBlock" />
        <meta
          name="twitter:description"
          content="The payments network for a borderless world."
        />
        <meta name="twitter:image" content={"%PUBLIC_URL%/logo.png"} />
        <meta name="twitter:site" content="@joinnu_" />
      </Helmet>
      <div className={style.card}>
        <div className={style.overlay}>
          <div className={style.content}>
            <HeadingAnimation
              text={heading}
              transitionDuration={0.5}
              className={style.heading}
              setHeadingCompleted={setHeadingCompleted}
            />
            {headingCompleted ? (
              <SubHeadingAnimation
                text={sub}
                className={style.sub}
                transitionDuration={0.35}
              />
            ) : (
              <div
                style={{
                  visibility: "hidden",
                  fontSize: "1.6rem",
                  marginTop: "1rem",
                }}
              >
                {sub}
              </div>
            )}
          </div>
        </div>
      </div>
      <Banner1 />
      <Banner2 />
      <Banner3 />
    </>
  );
};

export default LandingPage;
